import { combineReducers } from "redux";
import { LOGOUT } from "./constants/auth";
import auth from "./reducers/auth";
import serverConstants from "./reducers/serverConstants";
import doctorsQueueTimers from "./reducers/doctorsQueue";
import queueCount from "./reducers/queueCount";

const appReducer = combineReducers({
  auth,
  serverConstants,
  doctorsQueueTimers,
  queueCount
});

const rootReducer = (_state, action) => {
  let state = _state;
  //here we will reset the whole redux state when the user will logout
  if (action.type === LOGOUT) {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
